import React, { useState, useEffect, useRef, useMemo } from 'react';
import moment from 'moment'

// react component for creating dynamic tables
import ReactTable from "react-table";
import DatePicker from 'react-date-picker';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TripFinancials from "components/TripFinancials";

import {
    TextField,
    Select,
    MenuItem
  } from '@material-ui/core';
// Table Data
import columns from 'tables/columns/trips.json';
import { getTrips, formatTrips } from 'tables/rows/trips';

const pathToType = {
    alltrips: undefined,
    otrtrips: 'OTR',
    brokertrips: 'Broker',
    localtrips: 'Local'
};

const dateOptions = [
    {
      label: 'Dispatch Date',
      value: 'dispatchedAt',
    },
    {
      label: 'Departure Date',
      value: 'estimatedDeparture',
    },
    {
      label: 'Created At',
      value: 'createdAt',
    }
  ];
  
const initialDateState = {
    start: null,
    end: null,
    filterBy: ''
}



const TripsTable = () => {
    const [dateState, setDateState] = useState(initialDateState);
    const [statuses, setStatuses] = useState([]);
    const [forceUpdate, setForceUpdate] = useState(false);
    const tableNode = useRef();
    const [trips, setTrips] = useState([]);
    const [financials, setFinancials] = useState({
        revenue: 0,
        expenses: 0,
        cmTotal: 0,
        cmPercent: 0
    });
    const [getAll, setGetAll] = useState(false);

    const filteredTrips = useMemo(() => {
        if (!statuses.length && !(dateState.start || dateState.end)) return trips;
        const statusFilters = statuses.map(filter => filter.toLowerCase());
    
        return trips.filter(trip => {
          if (statusFilters.length && !statusFilters.includes(trip.status.toLowerCase())) return false;
            
          if (trip[dateState.filterBy]) {
            if ((dateState.start || dateState.end) && dateState.filterBy && !(trip[dateState.filterBy] || trip[dateState.filterBy].split('/').length !== 3)) return false;
          }
          // if ((!(dateState.start || dateState.end)) && order[dateState.filterBy].split('/').length !== 3) return false;
    
          const toJSDate = (strDate) => {
            let [month, day, year] = strDate.split('/');
            return new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
          }
    
          if (trip[dateState.filterBy]) {
            if ((dateState.start || dateState.end) && dateState.filterBy) {
                console.log("date: " + trip[dateState.filterBy].toDate())
                //const chosenDate = toJSDate(trip[dateState.filterBy]);
                const chosenDate = trip[dateState.filterBy].toDate();
        
                if (dateState.start && moment(chosenDate).isBefore(dateState.start)) return false;
        
                if (dateState.end && moment(chosenDate).isAfter(dateState.end)) return false;
            }
          }

          if (dateState.filterBy) {
            if (!trip[dateState.filterBy]) { return false }
          }
    
          return true;
        });
        
      }, [trips, dateState, statuses]);

    const activeStatuses = useMemo(() => {
        const statusObject = {};
        const tableOrders = trips;
        for (let i = 0; i < tableOrders.length; i++) {
          if (!statusObject[tableOrders[i].status]) statusObject[tableOrders[i].status] = true;
        };
    
        return Object.keys(statusObject);
      }, [trips, forceUpdate]);
    

    const handleDateChange = (date, key) => {
        setDateState(prev => ({
          ...prev,
          [key]: date
        }));
      }
    
      const handleDateOptionChange = (e) => {
        e.persist();
        setDateState(prev => ({
          ...prev,
          filterBy: e.target.value
        }))
      }

    const getTableTrips = (limited = true) => {
        getTrips(pathToType[window.location.pathname.split('/')[2]], limited)
            .then(formatTrips)
            .then(setTrips);
    }

    const getAllTrips = () => {
        setGetAll(true);
        getTableTrips(false);
    }

  

    const selectFilters = (e, newValues) => {
        setStatuses(newValues)
        getFinancialData()
      }

    const getFinancialData = () => {
        const filteredTable = tableNode.current.getResolvedState().sortedData;

        console.log(filteredTable)
        console.log(filteredTrips)

        const remCommas = dollarValue => dollarValue.replace(/\$|,/g, '');
        const commaFy = (dollarValue) => dollarValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        let revenue = 0;
        let expenses = 0;

        for (let i = 0; i < filteredTrips.length; i++) {
            if (filteredTrips[i].totalRevenue) revenue += parseFloat(remCommas(typeof filteredTrips[i].totalRevenue === 'string' ? filteredTrips[i].totalRevenue : filteredTrips[i].totalRevenue.toString()));
            if (filteredTrips[i].tripRate) expenses += parseFloat(remCommas(typeof filteredTrips[i].tripRate === 'string' ? filteredTrips[i].tripRate : filteredTrips[i].tripRate.toString()));
        }


        revenue = revenue.toFixed(2);
        expenses = expenses.toFixed(2);
        const contribution = (revenue - expenses).toFixed(2);
        const contributionPercent = ((contribution / revenue) * 100).toFixed(2);

        setFinancials({
            revenue: commaFy(revenue),
            expenses: commaFy(expenses),
            contribution: commaFy(contribution),
            contributionPercent
        })
    }

    useEffect(() => {
        if (trips.length) setTrips([]);
        
        getTableTrips();
    }, [window.location.pathname]);

    useEffect(() => {
        getFinancialData();
    }, [trips]);
 
    return (
        <React.Fragment>
        {tableNode.current && (
          <TripFinancials orders={tableNode.current} />
        )}
  
       <GridContainer>
             {/* <GridItem xs={6} sm={3}>
                <GridContainer justify='center'>
                    <GridItem>
                        <h5 style={{ textAlign: 'center' }}>
                            Filtered Revenue
                        </h5>
                    </GridItem>
                    <GridItem xs={12}>
                        <p style={{ textAlign: 'center', color: 'limegreen' }}>
                            $ {financials.revenue}
                        </p>
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem xs={6} sm={3}>
                <GridContainer justify='center'>
                    <GridItem>
                        <h5 style={{ textAlign: 'center' }}>
                            Filtered Expenses
                        </h5>
                    </GridItem>
                    <GridItem xs={12}>
                        <p style={{ textAlign: 'center', color: 'red' }}>
                            $ {financials.expenses}
                        </p>
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem xs={6} sm={3}>
                <GridContainer justify='center'>
                    <GridItem>
                        <h5 style={{ textAlign: 'center' }}>
                            Filtered Contribution
                        </h5>
                    </GridItem>
                    <GridItem xs={12}>
                        <p style={{ textAlign: 'center', color: 'limegreen' }}>
                            $ {financials.contribution}
                        </p>
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem xs={6} sm={3}>
                <GridContainer justify='center'>
                    <GridItem>
                        <h5 style={{ textAlign: 'center' }}>
                            Filtered Contribution Percent
                        </h5>
                    </GridItem>
                    <GridItem xs={12}>
                        <p style={{ textAlign: 'center' }}>
                            {financials.contributionPercent} %
                        </p>
                    </GridItem>
                </GridContainer>
            </GridItem> */}
            <GridItem xs={12}>
          <GridContainer justify='center' style={{ marginBottom: '8px' }} alignItems='center'>
            <GridItem>
              <Select
                value={dateState.filterBy}
                onChange={handleDateOptionChange}
                style={{ marginTop: '24px', width: '150px' }}
              >
                {dateOptions.map((option, i) => (
                  <MenuItem value={option.value} key={i}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </GridItem>
            <GridItem>
              <p style={{ textAlign: 'center' }}>Start</p>
              <DatePicker
                onChange={(e) => handleDateChange(e, 'start')}
                value={dateState.start}
                maxDate={dateState.end}
              />
            </GridItem>
            <GridItem>
              <p style={{ textAlign: 'center' }}>End</p>
              <DatePicker
                onChange={(e) => handleDateChange(e, 'end')}
                value={dateState.end}
                minDate={dateState.start}
              />
            </GridItem>
          </GridContainer>
        </GridItem>
        {console.log("ziggy" + activeStatuses)}
        <GridItem xs={6}>
          <Autocomplete
            multiple
            options={activeStatuses}
            getOptionLabel={(option) => option}
            value={statuses}
            filterSelectedOptions
            renderInput={(params) => (
              <TextField
                {...params}
                label="Statuses"
                variant="outlined"
                fullWidth
              />
            )}
            onChange={selectFilters}
          />
        </GridItem>
            <GridItem xs={12}>
                {getAll ? null : (
                    <Button
                        color='primary'
                        onClick={getAllTrips}
                    >
                        GET ALL TRIPS
                    </Button>
                )}
               
                <ReactTable
                    ref={tableNode}
                    data={filteredTrips}
                    filterable
                    columns={columns.columns}
                    defaultPageSize={50}
                    defaultFilterMethod={(filter, row) => {
                        const id = filter.pivotId || filter.id;
                        return (
                            row[id] !== undefined ?
                                (String(row[id]).toLowerCase()).includes(filter.value.toLowerCase())
                                :
                                true
                        );
                    }}
                    onFilteredChange={getFinancialData}
                    style={{
                        color: "#000"
                    }}
                    defaultSorted={[
                        {
                            id: 'tripNumber',
                            desc: true
                        }
                    ]}
                    className="-striped -highlight"
                />
            </GridItem>
        </GridContainer>
        </React.Fragment>

    );
}

export default TripsTable;


// WEBPACK FOOTER //
// ./src/views/Trips/TripsTable.jsx